import { throttle, isEqual } from 'lodash'
import { useEffect, useState, useRef, useMemo } from 'react'

export function useThrottledState<T>(initialState: T, delay: number = 250) {
  const [state, setState] = useState(initialState)
  const initialStateRef = useRef(initialState)

  const throttledSetState = useMemo(
    () => throttle((newState: T) => setState(newState), delay, { trailing: true }),
    [delay]
  )

  useEffect(() => {
    // Use deep comparison to avoid unnecessary updates
    if (!isEqual(initialStateRef.current, initialState)) {
      initialStateRef.current = initialState
      throttledSetState(initialState)
    }
  }, [initialState, throttledSetState])

  return state
}
